export interface SupportedTokens {
  base: string[];
  quote: string[];
}

export interface SupportedTokensState {
  data: SupportedTokens | null;
}

export enum SupportedTokensCommands {
  SupportedTokens = 'SupportedTokens',
}
